import useOrganizations from "../../hooks/useOrganizations";
import CustomSwitch from "../../components/common/CustomSwicth";


const SkeletonLoader = () => {
  return (
    <div className="skeleton-loader">
      <Skeleton height={20} />
      <Skeleton height={20} />
      <Skeleton height={20} />
      <Skeleton height={20} />
      <Skeleton height={20} />
    </div>
  );
};

const Organization = () => {
  const navigate = useNavigate();
  const {
    organizationsData,
    isLoading,
    organizationsError,
    deleteOrganization, organizationStatusChange, setOrganizationsData
  } = useOrganizations();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedOrganizationId, setSelectedOrganizationId] = useState(null);

  const handleAddNewButtonClick = () => {
    navigate("/organization/new");
  };

  const handleDeleteButtonClick = (organizationId) => {
    // console.log("delete", organizationId);
    setSelectedOrganizationId(organizationId);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    await deleteOrganization(selectedOrganizationId);
    setShowDeleteModal(false);
    toast.success("Organization deleted successfully");
  };

  const handleStatusToggle = async (organizationId, action) => {
    try {
      // console.log({ organizationId, action });
      const res = await organizationStatusChange(organizationId, action);
      if (res) {
        console.log(res);
        setOrganizationsData((previousOrganizationsData) =>
          previousOrganizationsData.map((organization) =>
            organization.id === organizationId ? { ...organization, is_active: !organization.is_active } : organization
          )
        );

        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error(error.message, toastOptions);
    }
  };


  const columns = [
    {
      name: "Serial",
      selector: (row, index) => <Link to={`/organization/${row.id}`}> {index + 1}</Link>,
      sortable: true,
      grow: 1,
    },

    {
      name: "Name",
      cell: (row) => <Link to={`/organization/${row.id}`}>{row.name}</Link>,
      sortable: true,
      grow: 4,
    },
    {
      name: "Email",
      selector: (row) => <Link to={`/organization/${row.id}`}> {row.email}</Link>,
      sortable: true,
      grow: 4,
    },
    {
      name: "Phone",
      selector: (row) => <Link to={`/organization/${row.id}`}>{row.phone}</Link>,
      sortable: true,
      grow: 2,

    },

    {
      name: "Status",
      selector: (row) => (
        <div className="d-flex justify-content-center align-items-center">
          <CustomSwitch
            id={`switch-${row.id}`}
            checked={row.is_active}
            onChange={() => handleStatusToggle(row.id, row.is_active ? 'disable' : 'enable')}
          />
        </div>
      ),
      sortable: true,
      center: true,
    },
    {
      name: "Actions",
      grow: 4,
      cell: (row) => (

        <div className="action-group">

          <Link to={`/organization/edit/${row.id}`} className="ms-3">
            <Button variant="warning">
              <FaPencilAlt />
            </Button>
          </Link>

          <Button
            variant="danger"
            onClick={() => handleDeleteButtonClick(row.id)}

          >
            <FaTrash />
          </Button>
        </div>
      ),
      center: true,

    },


  ];


  return (
    <Layout>

      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title">Organizations</h1>
        </div>
        <div className="page-header-right">
          <Button variant="primary" onClick={handleAddNewButtonClick}>
            {" "}
            <span className="me-1">
              <FaPlus style={{ color: "white" }} />
            </span>
            Add New
          </Button>
        </div>

      </div>
      <div className="container-fluid">
        <div className="px-3">
          {isLoading && <SkeletonLoader />}
          {organizationsError && <div>Error: {organizationsError}</div>}
          {!isLoading && !organizationsError && (
            <Card>
              <Card.Body>
                <div className="table-responsive">
                  <DataTable

                    columns={columns}
                    data={organizationsData}
                    fixedHeader
                    pagination
                    highlightOnHover

                  />



                </div>
              </Card.Body>
            </Card>
          )}
        </div>
      </div>
      <DynamicModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        title="Confirm Deletion"
        body="Do you want to delete this organization permanently?"
        primaryButtonText="Yes"
        secondaryButtonText="No"
        onPrimaryButtonClick={handleConfirmDelete}
        onSecondaryButtonClick={() => setShowDeleteModal(false)}
      />
    </Layout>
  );
};

export default Organization;
